module.exports = __webpack_public_path__ + "img/link04_sp.f7cd6b5a.png";